<template>
  <b-card
    class="shadow-sm rounded mb-3"
    role="region"
    aria-labelledby="info-area-title"
    aria-describedby="info-area-desc"
  >
    <b-card-title id="info-area-title">
      <translate>Infos</translate>
    </b-card-title>
    <div id="info-area-desc">
      <p>
        <strong><translate>Category</translate></strong
        >:
        {{ project.category }}
      </p>
      <p v-if="project.ends_at">
        <strong><translate>Ends on</translate></strong
        >:
        {{ formatDate(project.ends_at) }}
      </p>
      <p class="margin-bottom-0">
        <strong><translate>Address</translate></strong
        >: {{ project.street }} {{ project.postal_code }}, {{ project.city }}, {{ project.country }}
      </p>
    </div>
  </b-card>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

import { IExploreProjectDetail } from '@/types/projects'
@Component({
  name: 'info-area',
})
export default class InfoArea extends Vue {
  @Prop() project!: IExploreProjectDetail

  // Get localised date
  formatDate(dateString: string): string {
    if (!dateString) {
      return '-'
    }
    return this.$moment(dateString).format('LL')
  }
}
</script>
